{
    "(save {highestYearlyDiscount}%)": "",
    "{amount} days free": "{amount} dagar án endurgjalds",
    "{amount} off": "{amount} afsláttur",
    "{amount} off for first {number} months.": "{amount} afsláttur fyrstu {number} mánuðina.",
    "{amount} off for first {period}.": "{amount} afsláttur fyrsta {period}",
    "{amount} off forever.": "{amount} afsláttur um ókomna tíð.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% afsláttur",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} fær framvegis ekki fréttabréf frá {newsletterName}.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} fær framvegis ekki tölvupóst þegar einhver svarar ummælum þínum.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} fær framvegis ekki þetta fréttabréf.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "dagar án endurgjalds",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Aðgangur",
    "Account details updated successfully": "",
    "Account settings": "Aðgangsstillingar",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Þegar prufutímabili lýkur muntu greiða venjulegt verð í samræmi við áskriftarleiðina sem þú valdir. Þú getur ávallt sagt upp áskriftinni áður en til þess kemur.",
    "Already a member?": "Ertu nú þegar með áskrift?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Óvænt villa kom upp. Vinsamlegast reynið aftur eða <a>hafið samband</a> ef villan reynist þrálát.",
    "Back": "Til baka",
    "Back to Log in": "Aftur til innskráningar",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Svartur föstudagur",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Segðu upp hvenær sem er",
    "Cancel subscription": "Segja upp áskrift",
    "Canceled": "",
    "Cancellation reason": "Ástæða uppsagnar",
    "Change": "Breyta",
    "Change plan": "",
    "Check spam & promotions folders": "Athugið ruslpósta- eða kynningarefnismöppur",
    "Check with your mail provider": "Hafið samband við þjónustuveitanda netfangsins",
    "Check your inbox to verify email update": "",
    "Choose": "Velja",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Velja aðra áskriftarleið",
    "Choose a plan": "",
    "Choose a tier": "",
    "Choose your newsletters": "Velja fréttabréf",
    "Click here to retry": "Smellið hér til að reyna aftur",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Loka",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Ummæli",
    "Complimentary": "Í kaupbæti",
    "Confirm": "Staðfesta",
    "Confirm cancellation": "Staðfesta uppsögn",
    "Confirm subscription": "Staðfesta áskrift",
    "Contact support": "Hafa samband við þjónustuver",
    "Continue": "Áfram",
    "Continue subscription": "Halda áfram í áskrift",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "Innskráning mistókst. Hlekkurinn varð óvirkur.",
    "Could not update email! Invalid link.": "Breyting á netfangi mistókst! Ógildur hlekkur.",
    "Create a new contact": "Skrá nýjan tengilið",
    "Current plan": "Núgildandi áskriftarleið",
    "Delete account": "Eyða aðgangi",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Var þetta ætlunin? Breyttu stillingunum <button>hér</button>.",
    "Don't have an account?": "Ertu ekki með aðgang?",
    "Edit": "Breyta",
    "Email": "Netfang",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Fréttabréf",
    "Email newsletter settings updated": "",
    "Email preferences": "Stillingar netfangs",
    "Email preferences updated.": "",
    "Emails": "Netföng",
    "Emails disabled": "Netföng gerð óvirk",
    "Ends {offerEndDate}": "Lýkur {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "Villa",
    "Expires {expiryDate}": "Rennur út {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "Að eilífu",
    "Free Trial – Ends {trialEnd}": "Ókeypis prufutímabil – Lýkur {trialEnd}",
    "From": "",
    "Get help": "Fá aðstoð",
    "Get in touch for help": "Hafðu samband til að fá aðstoð",
    "Get notified when someone replies to your comment": "Fá tilkynningu þegar einhver svarar ummælum þínum",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Gefðu þessari færslu endurgjöf",
    "Help! I'm not receiving emails": "Hjálp! Ég fæ ekki tölvupósta",
    "Here are a few other sites you may enjoy.": "",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Ef fréttabréf er flokkað sem ruslpóstur er lokað fyrir tölvupósta á netfangið til að tryggja að þú fáir ekki þarflaus skilaboð.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Ef kvörtunin um ruslpóstinn var óviljandi eða ef þú vilt fá tölvupósta að nýju, geturðu endurvakið áskriftina með því að smella á hnappinn sem birtist í glugganum á undan.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Ef þú segir upp áskriftinni núna muntu áfram hafa aðgang fram til {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Ef þú ert með aðgang í nafni fyrirtækis eða ríkisstofnunar geturðu haft samband við upplýsingatæknideildina og beðið hana um að leyfa viðtöku tölvupósta frá {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Innskráningarhlekkur hefur verið sendur á netfangið þitt. Ef hann er ekki kominn innan 3ja mínútna skaltu athuga spam-möppuna.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Ef þú vilt fá tölvupósta að nýju er nærtækast að athuga hvort netfangið sé í lagi og smella síðan á endurnýja áskrift í glugganum á undan.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Ef þú færð ekki fréttabréfið sem þú ert í áskrift að þá eru hér nokkur atriði sem hægt er að skoða:",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Ef þú hefur skoðað öll þess atriði og færð enn ekki tölvupósta geturðu haft samband við {supportAddress}",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Ef varanleg villa kemur upp við sendingu tölvupósta verða þeir gerðir óvirkir.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Bættu {senderEmail} við listann yfir tengiliði í tölvupósthólfinu. Það gefur þjónustuveitandanum merki um að tölvupóstum frá þessu netfangi sé treystandi.",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "Minna af þessu tagi",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Gakktu úr skugga um að tölvupóstanir endi ekki í möppum fyrir ruslpósta eða kynningarefni. Ef svo er skaltu smella á \"Mark as not spam\" og/eða \"Move to inbox\"",
    "Manage": "Stjórna",
    "Maybe later": "",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "",
    "month": "",
    "Monthly": "Mánaðarlega",
    "More like this": "Meira af þessu tagi",
    "More options": "",
    "Name": "Nafn",
    "Need more help? Contact support": "Þarftu meiri aðstoð? Hafðu samband við þjónustuverið",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Færðu ekki tölvupósta?",
    "Now": "",
    "Now check your email!": "Athugaðu nú tölvupósthólfið þitt!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Ef þú sérð ekki tölvupósta eftir að hafa endurvakið áskrift, athugaðu spam-möppuna. Enn kunna að vera skráðar kvartanir um ruslpóst og tölvupóstarnir því flokkaður á þann veg. Ef svo er skaltu merkja síðasta fréttabréf sem 'Not spam' og færa yfir í aðalpósthólfið.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Varanleg villa",
    "Phone number": "",
    "Plan": "Áskriftarleið",
    "Plan checkout was cancelled.": "Hætt var við kaup á áskrift",
    "Plan upgrade was cancelled.": "Hætt var við breytingu á áskriftarleið",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Vinsamlegast hafið samband við {supportAddress} til að breyta kaupbætisáskrift.",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "Vinsamlegast fyllið í nauðsynlega reiti",
    "Podcasts": "",
    "Re-enable emails": "Fá tölvupósta að nýju",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "Endurnýjast á verðinu {price}",
    "Resume subscription": "",
    "Retry": "Reyna aftur",
    "Save": "Vista",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Sendi innskráningarhlekk",
    "Sending...": "Sending í vinnslu",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "",
    "Sign in": "Innskráning",
    "Sign out": "Útskráning",
    "Sign up": "Nýskráning",
    "Signup error: Invalid link": "Villa við nýskráningu: Ógildur hlekkur",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Þetta virkaði því miður ekki.",
    "Spam complaints": "Kvartanir um ruslpóst",
    "Start {amount}-day free trial": "Hefja {amount}-daga prufutímabil",
    "Starting {startDate}": "Frá og með {startDate}",
    "Starting today": "Frá og með deginum í dag",
    "Submit feedback": "Gefa endurgjöf",
    "Subscribe": "Áskrift",
    "Subscribed": "Í áskrift",
    "Subscription plan updated successfully": "",
    "Success": "Þetta heppnaðist",
    "Success! Check your email for magic link to sign-in.": "Þetta heppnaðist! Athugaðu tölvupósthólfið til að finna hlekk til innskráningar.",
    "Success! Your account is fully activated, you now have access to all content.": "Þetta heppnaðist! Aðgangurinn þinn er virkur, þú hefur nú aðgang að öllu efni.",
    "Success! Your email is updated.": "Þetta heppnaðist! Breyting á netfangi hefur tekið gildi.",
    "Successfully unsubscribed": "Uppsögn heppnaðist",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "Takk fyrir endurgjöfina!",
    "That didn't go to plan": "Þetta fór ekki samkvæmt áætlun",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Netfangið sem þú ert skráður fyrir er {memberEmail} — ef það er rangt geturðu breytt því í <button>aðgangsstillingum</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Villa kom upp við sendingu athugasemdar. Vinsamlegast reynið aftur örlítið síðar.",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Aðgangur krefst boðsmiða, hafið samband við eiganda síðunnar til að fá aðgang.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Til að ljúka nýskráningu skaltu smella á staðfestingarhlekkinn sem var sendur á netfangið þitt. Ef hann er ekki kominn innan 3 mínútna skaltu athuga spam-möppuna.",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Prófaðu í {amount} daga án endurgjalds og síðan fyrir {originalPrice}",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Fáðu aðgang að öllum fréttabréfum með því að gerast áskrifandi.",
    "Unsubscribe from all emails": "Segja upp öllum tölvupóstum",
    "Unsubscribed": "Ekki í áskrift",
    "Unsubscribed from all emails.": "",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Uppsögn tölvupósta felur ekki í sér uppsögn áskriftar að {title}",
    "Update": "Uppfæra",
    "Update your preferences": "Breyta vali",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "",
    "Verify your email address is correct": "Gakktu úr skugga um að netfangið sé rétt",
    "Verifying...": "",
    "View plans": "Skoða áskriftarleiðir",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Uppsögn mistókst vegna þess að netfangið fannst ekki. Hafðu samband við eiganda síðunnar.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Velkominn aftur, {name}!",
    "Welcome back!": "Velkominn aftur!",
    "Welcome to {siteTitle}": "",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Þegar netfang getur ekki tekið við tölvupósti er það oftast tímabundin villa en í sumum tilfellum, þegar netfangið er ógilt eða ekki til staðar, er villan varanleg.",
    "Why has my email been disabled?": "Hvers vegna var netfangið mitt gert óvirkt?",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "Árlega",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Þú ert með gjaldfrjálsan aðgang eins og stendur, keyptu áskrift til að fá fullan aðgang.",
    "You have been successfully resubscribed": "Þú ert orðinn áskrifandi að nýju",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Þú færð ekki tölvupósta eins og stendur",
    "You're not receiving emails": "Þú færð ekki tölvupósta",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Þú færð ekki tölvupósta ýmist vegna þess að þú merktir síðustu skilaboð sem ruslpóst eða vegna þess að ekki er hægt að senda skilaboð á netfangið sem þú gafst upp.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Þér tókst að skrá þig inn",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "",
    "Your account": "Aðgangurinn þinn",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Áskrift þinni lýkur {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Áskrift þín verður endurnýjuð {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Áskrift þín hefst {subscriptionStart}"
}
